"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionRelationUpdate = exports.CollectionRelationUpdateAction = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.CollectionRelationUpdateAction = typebox_1.Type.Union([
    typebox_1.Type.Literal('CREATE'),
    typebox_1.Type.Literal('UPDATE'),
    typebox_1.Type.Literal('DELETE'),
]);
const CollectionRelationUpdate = (create, update, idType) => typebox_1.Type.Array(typebox_1.Type.Object({
    action: exports.CollectionRelationUpdateAction,
    id: typebox_1.Type.Optional(idType),
    payload: typebox_1.Type.Optional(typebox_1.Type.Union([create, update])),
}));
exports.CollectionRelationUpdate = CollectionRelationUpdate;
//# sourceMappingURL=collection-relation-update.js.map